import "phaser";

import AudioEngine from "../audio_engine";
import LevelState from "./level";

export default class BootState extends Phaser.State {
    loadingBar: Phaser.Graphics;
    loadingText: Phaser.Text;
    loadingBg: Phaser.Sprite;

    init() {
        const bgGroup = this.game.add.group();
        const img = new Image();
        this.game.stage.backgroundColor = "#000000";

        img.src = require("!base64-inline-loader!../../assets/sprites/bg2.png");
        img.onload = () => {
            this.game.cache.addImage('loading-bg', require("!base64-inline-loader!../../assets/sprites/bg2.png"), img);
            this.loadingBg = this.game.add.sprite(0, 0, 'loading-bg');
            bgGroup.add(this.loadingBg);
            this.loadingBg.alpha = 0;
        };

        this.loadingBar = this.game.add.graphics(0, 0);
        this.loadingText = this.game.add.text(
            this.game.width / 2, this.game.height / 2 + 32, "",
            {
                font: "Avenir, 'Segoe UI', 'Noto Sans', 'Helvetica', sans-serif",
                fontSize: 24,
                fill: "#FFFFFF",
            });
        this.loadingText.anchor.setTo(0.5, 0.5);
        this.updateLoadingBar();
    }

    updateLoadingBar() {
        this.loadingBar.clear();
        this.loadingBar.beginFill(0xFFFFFF);
        const progress = 3 * this.load.progress;
        this.loadingBar.drawRect(this.game.width / 2 - progress / 2, this.game.height / 2 - 15, progress, 30);
        this.loadingText.text = `${this.load.progress}%`;
        this.loadingBar.endFill();

        if (this.loadingBg) {
            const percent = this.load.progress / 100;
            this.loadingBg.alpha = 0.4 + 0.6 * percent;
        }
    }

    loadUpdate() {
        this.updateLoadingBar();
    }

    preload() {
        this.game.load.image("title-whole", require("../../assets/sprites/kirigami-whole-shadow.png"));
        this.game.load.image("title-bottom", require("../../assets/sprites/kirigami-bottom-shadow.png"));
        this.game.load.image("title-top", require("../../assets/sprites/kirigami-top-shadow.png"));
        this.game.load.image("cut", require("../../assets/sprites/cut.png"));
        this.game.load.image("triangle", require("../../assets/sprites/triangle-select.png"));
        this.game.load.image("play-button", require("../../assets/sprites/play-text.png"));

        this.game.load.image("select-level", require("../../assets/sprites/select-level.png"));

        this.game.load.image("shrine", require("../../assets/sprites/shrine-select.png"));
        this.game.load.image("lock", require("../../assets/sprites/lock.png"));
        this.game.load.image("play", require("../../assets/sprites/triangle-select.png"));

        this.game.load.bitmapFont("number-font", require("../../assets/fonts/no_continue.png"),
                                  undefined,
                                  require("../../assets/fonts/no_continue.fnt"));

        this.game.load.image("platform-l", require("../../assets/sprites/platform-edge-L.png"));
        this.game.load.image("platform-r", require("../../assets/sprites/platform-edge-R.png"));
        this.game.load.image("platform-body", require("../../assets/sprites/platform-mid.png"));

        this.game.load.image("spike-l", require("../../assets/sprites/spike-edge-L.png"));
        this.game.load.image("spike-r", require("../../assets/sprites/spike-edge-R.png"));
        this.game.load.image("spike-body", require("../../assets/sprites/spike-edge-mid.png"));

        this.game.load.image("temple-balcony-l", require("../../assets/sprites/temple-balcony-L.png"));
        this.game.load.image("temple-balcony-r", require("../../assets/sprites/temple-balcony-R.png"));
        this.game.load.image("temple-body", require("../../assets/sprites/temple-body.png"));

        this.game.load.image("temple-roof-l", require("../../assets/sprites/temple-roof-edge-L.png"));
        this.game.load.image("temple-roof-r", require("../../assets/sprites/temple-roof-edge-R.png"));
        this.game.load.image("temple-roof", require("../../assets/sprites/temple-roof-mid.png"));

        this.game.load.image("lantern-l", require("../../assets/sprites/lantern-edge-L.png"));
        this.game.load.image("lantern-r", require("../../assets/sprites/lantern-edge-R.png"));
        this.game.load.image("lantern-body", require("../../assets/sprites/lantern-mid.png"));

        this.game.load.image("shrine-top-l-1", require("../../assets/sprites/shrine-top-l-1.png"));
        this.game.load.image("shrine-top-l-2", require("../../assets/sprites/shrine-top-l-2.png"));
        this.game.load.image("shrine-top-l-3", require("../../assets/sprites/shrine-top-l-3.png"));
        this.game.load.image("shrine-top-l-4", require("../../assets/sprites/shrine-top-l-4.png"));
        this.game.load.image("shrine-top-r-1", require("../../assets/sprites/shrine-top-r-1.png"));
        this.game.load.image("shrine-top-r-2", require("../../assets/sprites/shrine-top-r-2.png"));
        this.game.load.image("shrine-top-r-3", require("../../assets/sprites/shrine-top-r-3.png"));
        this.game.load.image("shrine-top-r-4", require("../../assets/sprites/shrine-top-r-4.png"));
        this.game.load.image("shrine-leg-l", require("../../assets/sprites/shrine-leg-l.png"));
        this.game.load.image("shrine-leg-r", require("../../assets/sprites/shrine-leg-r.png"));

        this.game.load.image("blank", require("../../assets/sprites/blank.png"));
        this.game.load.spritesheet("done", require("../../assets/sprites/done.png"), 39, 40);
        this.game.load.spritesheet("cancel", require("../../assets/sprites/cancel.png"), 39, 40);
        this.game.load.image("laser", require("../../assets/sprites/laser emitter.png"));

        this.game.load.spritesheet("undo-button", require("../../assets/sprites/undo.png"), 79, 80);

        this.game.load.image("background2", require("../../assets/sprites/bg2.png"));
        this.game.load.image("background3", require("../../assets/sprites/bg3.png"));
        this.game.load.image("background5", require("../../assets/sprites/bg5.png"));
        this.game.load.image("background6", require("../../assets/sprites/bg6.png"));
        this.game.load.image("background7", require("../../assets/sprites/bg7.png"));
        this.game.load.image("background8", require("../../assets/sprites/bg8.png"));
        this.game.load.image("cut", require("../../assets/sprites/cut.png"));
        this.game.load.spritesheet("ninja-spritesheet", require("../../assets/sprites/ninja-spritesheet.png"), 33, 48, -1, 1, 1);
        this.game.load.image("goal", require("../../assets/sprites/goal.png"));
        this.game.load.image("beam", require("../../assets/sprites/beam.png"));
        this.game.load.spritesheet("star", require("../../assets/sprites/star.png"), 30, 46);
        this.game.load.image("victory-star", require("../../assets/sprites/star2.png"));

        this.game.load.image("pointer", require("../../assets/sprites/circle-select.png"));

        this.game.load.bitmapFont("font", require("../../assets/fonts/no_continue.png"), undefined, require("../../assets/fonts/no_continue.fnt"));
-        this.game.load.bitmapFont("font-large", require("../../assets/fonts/no_continue_large.png"), undefined, require("../../assets/fonts/no_continue_large.fnt"));

        this.game.load.audio("slash", require("../../assets/sfx/slash.wav"));
        this.game.load.audio("hit_ground", require("../../assets/sfx/hit_ground.wav"));
        this.game.load.audio("walk_roof", require("../../assets/sfx/walk_roof.wav"));
        this.game.load.audio("collect_star", require("../../assets/sfx/collect_star.wav"));
        this.game.load.audio("hurt", require("../../assets/sfx/hurt.wav"));
        this.game.load.audio("hurt_echo", require("../../assets/sfx/hurt_echo.wav"));
        this.game.load.audio("laser", require("../../assets/sfx/laser.wav"));
        this.game.load.audio("firework", require("../../assets/sfx/firework_bass.wav"));
        this.game.load.audio("button_click", require("../../assets/sfx/button_click.wav"));
        this.game.load.audio("button_hover", require("../../assets/sfx/button_hover.wav"));

        this.game.load.spritesheet("restart", require("../../assets/sprites/restart.png"), 39, 40);
        this.game.load.spritesheet("menu", require("../../assets/sprites/menu.png"), 39, 40);

        this.game.load.image("china-flag", require("../../assets/sprites/flags/china.png"));
        this.game.load.image("korea-flag", require("../../assets/sprites/flags/korea.png"));
        this.game.load.image("america-flag", require("../../assets/sprites/flags/america.png"));
        this.game.load.image("japan-flag", require("../../assets/sprites/flags/japan.png"));

        this.game.load.image("shrine-star", require("../../assets/sprites/shrine-star.png"));
        this.game.load.image("sound_on", require("../../assets/sprites/sound_unmute.png"));
        this.game.load.image("sound_off", require("../../assets/sprites/sound_mute.png"));

        this.game.load.image("shrine-challenge", require("../../assets/sprites/shrine-challenge-select.png"));
        this.game.load.image("shrine-challenge-star", require("../../assets/sprites/shrine-challenge-star.png"));

        this.game.load.image("cursor-normal", require("../../assets/sprites/cursor_normal.png"));
        this.game.load.image("cursor-click", require("../../assets/sprites/cursor_click.png"));
        this.game.load.image("drag-line", require("../../assets/sprites/drag_line.png"));

        this.game.load.image("fog", require("../../assets/sprites/fog.png"));
    }

    create() {
        AudioEngine.initialize(this.game);
        this.game.state.start("title");
    }
}



// WEBPACK FOOTER //
// ./src/states/boot.ts